import {
  ArchiveSegmentMutation,
  Exact,
  SegmentFragment,
  useArchiveSegmentMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

export const useArchiveSegment = withStandardMutationHook<
  ArchiveSegmentMutation,
  SegmentFragment,
  Exact<{ name: string }>,
  'archiveSegment',
  [string]
>(useArchiveSegmentMutation, 'archiveSegment', (name: string) => ({
  name,
}));
